import React from "react";
import "./styles.css";
//import { AiOutlineSearch } from "react-icons/ai";
//import { IoIosArrowDown } from "react-icons/io";
//import { Collapse } from "react-collapse";
import FormRILogin from './../../../components/Forms_RepresentanteDeInstituição/Tela_RI_Login';
//import {NavLink} from 'react-router-dom';
import SideNav from './../../../components/SideNav';


export default function RI_Login() {
    //let [search, setSearch] = useState(false);
    //let [login, setLogin] = useState(false);
    return (
        <>
            <SideNav />
            <div id="top-RI-Cadastro"></div>
            <div id="main-RI-Login">
                <p id="RI-Login">Login</p>
                <hr id="divider-RI-Login" />
                <FormRILogin/>
            </div>

        </>
    );
}